import React, {Component} from 'react';

import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import AbstractMapMarker from "components/ui/map/base/marker";
import _ from 'lodash';
import GarbageIcon from "components/ui/map/markers/icons/garbage-icon";
import ReactPopup from "react-leaflet-popup";
import L from 'leaflet';

@propTypes({
    title: PropTypes.string,
    type: PropTypes.string,
    permanentTooltip: PropTypes.bool,
})

@defaultProps({
    title: '',
    type: null,
    permanentTooltip: false,
})

export default class GarbagePointMarker extends AbstractMapMarker {

    getOptions(props = null) {
        return _.merge(super.getOptions(), {
            icon: GarbageIcon.getIcon((props ? props.type : this.props.type) || 'kp'),
            riseOnHover: true,
        });
    }

    componentDidMount() {
        super.componentDidMount();


        /*if (this.props.title) {
            this.getMarker().bindTooltip(this.props.title, {
                sticky: true,
                permanent: this.props.permanentToolTip,
            });
        }*/
    }

    componentWillUpdate(props) {

        /*const marker = this.getMarker();
        const oldTitle = this.props.title;
        const newTitle = props.title;
        if (((oldTitle !== newTitle) || !marker.getTooltip())) {
            marker.unbindTooltip();
            if (newTitle) {
                marker.bindTooltip(newTitle, {
                    sticky: true,
                    permanent: this.props.permanentToolTip,
                });
            }
        }*/

        if (this.props.type !== props.type) {
            this.props.leafletMap.removeLayer(this.getMarker());
            this.init(props);
            this.props.leafletMap.addLayer(this.getMarker());
        }
    }

    componentWillMount() {
        super.componentWillMount();

        this.getMarker().on('click', ::this.loadPopup)
    }

    loadPopup() {
        if (!this.props.object) {
            return;
        }

        const marker = this.getMarker();
        marker.unbindPopup();
        marker.closePopup();
        marker.bindPopup(
            this.createPopup(::marker.closePopup)
        );
        marker.openPopup();
    }

    createPopup(onClose) {
        const {object} = this.props;

        return new ReactPopup({
            reactComponent: ObjectPopup,
            reactComponentProps: {
                ...this.props,
                object,
                onClose,
            },
            minWidth: 360,
            maxWidth: 360,
            offset: new L.Point(2, -230),
        });
    }

}

class ObjectPopup extends Component {

    render() {
        const {object, typeTitle, type} = this.props;

        return (
            <div className="b-modal b-modal-map map-tooltip-modal tooltip-locality footer-none display-block">
                <div className="b-modal__header">
                    <a href="#" className="b-modal__close" onClick={::this.onClose}/>
                    <div className="b-modal__name align-middle">{object.name}</div>
                </div>
                <div className="b-modal__body">
                    <div className="b-block">
                        <div className="b-block__desc">Тип</div>
                        <div className="b-block__value">{typeTitle}</div>
                    </div>
                    {(type !== 'kp') ? ([
                        <div key="capacity" className="b-block">
                            <div className="b-block__desc">Ёмкость</div>
                            <div className="b-block__value">{object.capacity}</div>
                        </div>,
                        <div key="contact" className="b-block">
                            <div className="b-block__desc">Контактная информация</div>
                            <div className="b-block__value">{object.contact}</div>
                        </div>,
                        <div key="license" className="b-block">
                            <div className="b-block__desc">Лицензия</div>
                            <div className="b-block__value">{object.license}</div>
                        </div>,
                    ]) : null}
                </div>
            </div>
        );
    }

    onClose(e) {
        e.preventDefault();
        this.props.onClose();
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/map/markers/garbage-point-marker.js